import productViewShippingPricesHtml from './productviewavshippingprices.component.html';
import './productviewavshippingprices.component.scss';

class ProductViewShippingPricesController {
    constructor($scope, $http) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.init = false;
    }

    $onInit() {
        this.pricesData = JSON.parse(unescape(this.prices));
        this.informationData = unescape(this.information).replace(/\\"/g, '"');
        this.init = true;
    }

    save() {

    }

    close() {
        this.$scope.$parent.$ctrl.close();
    }
}

let productViewShippingPricesComponent  = {
    bindings: {
        prices: '@',
        information: '@'
    },
    template: productViewShippingPricesHtml,
    controller: ProductViewShippingPricesController
}

export default productViewShippingPricesComponent;
